export const createCookie = function (name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
  } else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
  // console.log('created',name + "=" + value + expires + "; path=/");
};;

export const readCookie = function (name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const readCookieStartWith = function (findCookie) {
  const cookies = document.cookie.split(";");

  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split("=");
    if (name.startsWith(findCookie)) {
      return name; // or return { name, value } if you want both
    }
  }
};

export const removeCookie = function (name) {
  createCookie(name, null, -1);
};

export const watchCookie = function (name, successCallback, ErrorCallback) {
  // console.log('int started');
  var handle = setInterval(() => {
    if (
      readCookie(name) !== "" &&
      readCookie(name) !== undefined &&
      readCookie(name) !== null
    ) {
      successCallback(name);
    } else {
      // clearInterval(handle);
      ErrorCallback();
    }
  }, 2000);
};
